export default __webpack_public_path__ + "static/media/888.e02ed68c.jpg";